[
  {
    "class": "auto-loan",
    "text": "Auto Loan",
    "keys": ["auto", "vehicle", "ev", "electric"]
  },
  {
    "class": "auto-blue",
    "text": "Auto Blue",
    "keys": []
  },
  {
    "class": "auto-electric",
    "text": "Auto Electric",
    "keys": ["electric"]
  },
  {
    "class": "motorcycle-loan",
    "text": "Motorcycle Loan",
    "keys": ["motorcycle"]
  },
  {
    "class": "rv-loan",
    "text": "Rv Loan",
    "keys": ["travel", "bus", "rv"]
  },
  {
    "class": "truck",
    "text": "Truck",
    "keys": ["truck"]
  },
  {
    "class": "industrial",
    "text": "Industrial",
    "keys": ["industrial", "industry"]
  },
  {
    "class": "utility-trailer",
    "text": "Utility Trailer",
    "keys": ["trailer", "tow"]
  },
  {
    "class": "atv",
    "text": "Atv",
    "keys": ["atv", "offroad", "motorsport"]
  },
  {
    "class": "farm",
    "text": "Farm",
    "keys": ["farm", "tractor"]
  },
  {
    "class": "scooter",
    "text": "Scooter",
    "keys": ["scooter"]
  },
  {
    "class": "steering-wheel",
    "text": "Steering Wheel",
    "keys": []
  },
  {
    "class": "helmet",
    "text": "Helmet",
    "keys": []
  },
  {
    "class": "bicycle",
    "text": "Bicycle",
    "keys": ["bicycle"]
  },
  {
    "class": "car-charger",
    "text": "Car Charger",
    "keys": ["charger"]
  },
  {
    "class": "solar-panel",
    "text": "Solar Panel",
    "keys": ["solar"]
  },
  {
    "class": "home",
    "text": "Home",
    "keys": ["house"]
  },
  {
    "class": "home-repair",
    "text": "Home Repair",
    "keys": ["repair"]
  },
  {
    "class": "boat-loan",
    "text": "Boat Loan",
    "keys": ["boat", "watercraft"]
  },
  {
    "class": "ship",
    "text": "Ship",
    "keys": ["ship"]
  },
  {
    "class": "ocean",
    "text": "Ocean",
    "keys": []
  },
  {
    "class": "snowflake",
    "text": "Snowflake",
    "keys": []
  },
  {
    "class": "aircraft",
    "text": "Aircraft",
    "keys": ["aircraft"]
  },
  {
    "class": "helicopter",
    "text": "Helicopter",
    "keys": ["helicopter"]
  },
  {
    "class": "cash-coins",
    "text": "Cash Coins",
    "keys": []
  },
  {
    "class": "cash",
    "text": "Cash",
    "keys": ["heloc","equity"]
  },
  {
    "class": "cash-in-hand",
    "text": "Cash In Hand",
    "keys": []
  },
  {
    "class": "cash-lock",
    "text": "Cash Lock",
    "keys": []
  },
  {
    "class": "piggy-bank",
    "text": "Piggy Bank",
    "keys": []
  },
  {
    "class": "coin-hand",
    "text": "Coin Hand",
    "keys": []
  },
  {
    "class": "us-currency",
    "text": "Us Currency",
    "keys": ["personal", "secured", "ploc"]
  },
  {
    "class": "currency-folder",
    "text": "Currency Folder",
    "keys": []
  },
  {
    "class": "bar-graph-up",
    "text": "Bar Graph Up",
    "keys": ["stock"]
  },
  {
    "class": "bar-graph-up-alt",
    "text": "Bar Graph Up Alt",
    "keys": []
  },
  {
    "class": "line-graph",
    "text": "Line Graph",
    "keys": []
  },
  {
    "class": "credit-card",
    "text": "Credit Card",
    "keys": ["card", "credit card"]
  },
  {
    "class": "credit-card-in-hand",
    "text": "Credit Card In Hand",
    "keys": []
  },
  {
    "class": "amex-card",
    "text": "Amex Card",
    "keys": []
  },
  {
    "class": "discover-card",
    "text": "Discover Card",
    "keys": []
  },
  {
    "class": "mastercard-card",
    "text": "Mastercard Card",
    "keys": []
  },
  {
    "class": "visa-card",
    "text": "Visa Card",
    "keys": ["visa"]
  },
  {
    "class": "breifcase",
    "text": "Breifcase",
    "keys": []
  },
  {
    "class": "buildings",
    "text": "Buildings",
    "keys": []
  },
  {
    "class": "buildings-alt",
    "text": "Buildings Alt",
    "keys": []
  },
  {
    "class": "medical",
    "text": "Medical",
    "keys": ["medical"]
  },
  {
    "class": "wheelchair",
    "text": "Wheelchair",
    "keys": ["wheelchair", "disability", "mobility"]
  },
  {
    "class": "construction",
    "text": "Construction",
    "keys": ["construction"]
  },
  {
    "class": "apple",
    "text": "Apple",
    "keys": []
  },
  {
    "class": "gift",
    "text": "Gift",
    "keys": ["gift"]
  }
]
